export default "__VITE_ASSET__0f1a2bbf__"